import { ChangeDetectionStrategy, Component, LOCALE_ID, computed, inject, input, output } from '@angular/core';

import { PharmacySegment } from '../../../../../pages/admin-dashboard/pharmacy-segment/pharmacy-segment.model';
import { ActionInterface } from '../../../../../pages/admin-dashboard/pharmacies/pharmacies-list/pharmacies-list.model';
import { Tables } from '../../../../../shared/ui/shared-tables/tables/tables';
import { buildSegmentHeaderItems, mapSegmentsToRows } from './pharmacy-segment-table.mapper';
import { SEGMENT_ACTION_EDIT } from './pharmacy-segment-table.module';

@Component({
  selector: 'app-pharmacy-segment-table',
  standalone: true,
  imports: [Tables],
  templateUrl: './pharmacy-segment-table.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PharmacySegmentTable {
  private locale = inject(LOCALE_ID);

  segments = input.required<PharmacySegment[]>();
  currentPage = input(1);
  itemsPerPage = input(25);
  isFiltersApplied = input(false);

  edit = output<PharmacySegment>();

  private isArabic = computed(() => typeof this.locale === 'string' && this.locale.startsWith('ar'));

  headerItems = computed(() => buildSegmentHeaderItems(this.isArabic()));

  tableRows = computed(() =>
    mapSegmentsToRows(this.segments(), this.currentPage(), this.itemsPerPage(), this.isArabic())
  );

  rowActions: ActionInterface[] = [
    { id: SEGMENT_ACTION_EDIT, titleEn: 'Edit', titleAr: 'تعديل' },
  ];

  // Empty States
  emptyFilterTitle = computed(() =>
    this.isArabic()
      ? 'لا توجد شرائح تطابق نتائج البحث أو الفلترة'
      : 'No pharmacy segments match your criteria.'
  );

  emptyContentTitle = computed(() =>
    this.isArabic() ? 'لا توجد شرائح صيدليات' : 'No Pharmacy Segments Found'
  );

  emptyContentDescription = computed(() =>
    this.isArabic() ? 'لم يتم إضافة شرائح بعد.' : 'No pharmacy segments have been created yet.'
  );

  onHandleAction(payload: { event: Event; actionId: number; entity: any }): void {
    if (!payload?.entity) return;

    if (payload.actionId === SEGMENT_ACTION_EDIT) {
      this.edit.emit(payload.entity as PharmacySegment);
    }
  }
}